/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getReplay.defs.js";
export { main as default } from "./getReplay.defs.js";
